// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Client = require("../../clients/types/Client.bs.js");
var Entity = require("../../common/types/Entity.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Labels = require("../../clients/components/Labels.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Property = require("../../clients/types/Property.bs.js");
var BuyerNeed = require("../../clients/types/BuyerNeed/BuyerNeed.bs.js");
var ViewStack = require("../../common/ViewStack.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Card__Jsx3 = require("../../../uikit/reason/molecules/Card/Card__Jsx3.bs.js");
var HtmlHolder = require("../../common/HtmlHolder.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var PseudoJoin = require("../../../uikit/reason/helpers/PseudoJoin.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CurrentUser = require("../../common/CurrentUser/CurrentUser.bs.js");
var Next__Atoms = require("../../next/Next__Atoms.bs.js");
var ReactRender = require("../../utils/ReactRender.bs.js");
var Types__User = require("../../user/Types__User.bs.js");
var Theme__Color = require("../../common/Theme/Theme__Color.bs.js");
var Buttons__Jsx3 = require("../../../uikit/reason/atoms/Buttons/Buttons__Jsx3.bs.js");
var Types__Common = require("../../common/types/Types__Common.bs.js");
var CardComponents = require("../../matches/components/CardComponents.bs.js");
var RentalProperty = require("../../clients/types/RentalProperty.bs.js");
var Touchable__Jsx3 = require("../../../uikit/reason/atoms/Touchable/Touchable__Jsx3.bs.js");
var GraphQLConverter = require("../../common/GraphQLConverter.bs.js");
var User__Components = require("../../user/User__Components.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Colors = require("uikit/styles/colors");
var Conversations__Types = require("../types/Conversations__Types.bs.js");
var Utils__AttachmentUrl = require("../../../utils/Utils__AttachmentUrl.bs.js");
var TMPUIKIT___Price__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT____Price/TMPUIKIT___Price__Jsx3.bs.js");
var BroadcastMessage__Types = require("../../messages/types/BroadcastMessage__Types.bs.js");
var Clients__Components__AreaText = require("../../clients/components/Clients__Components__AreaText.bs.js");
var ConversationContextCard__Jsx3 = require("../../../uikit/reason/molecules/ConversationContextCard/ConversationContextCard__Jsx3.bs.js");
var ConversationContext__Property = require("../types/ConversationContext__Property.bs.js");
var Property__Components__Address = require("../../clients/components/Property/Property__Components__Address.bs.js");
var ConversationContext__BuyerNeed = require("../types/ConversationContext__BuyerNeed.bs.js");
var ConversationContext__RentalNeed = require("../types/ConversationContext__RentalNeed.bs.js");
var ConversationContext__RentalProperty = require("../types/ConversationContext__RentalProperty.bs.js");

function decode(x) {
  var variant = x.NAME;
  if (variant === "RentalProperty") {
    return Belt_Result.map(x.VAL, (function (i) {
                  return {
                          TAG: /* RentalProperty */4,
                          _0: i
                        };
                }));
  } else if (variant === "RentalNeed") {
    return Belt_Result.map(x.VAL, (function (i) {
                  return {
                          TAG: /* RentalNeed */5,
                          _0: i
                        };
                }));
  } else if (variant === "PublicBuyerNeedContext") {
    return Belt_Result.map(x.VAL.buyerNeed, (function (i) {
                  return {
                          TAG: /* PublicBuyerNeed */2,
                          _0: i
                        };
                }));
  } else if (variant === "PrivatePropertyContext") {
    return Belt_Result.map(x.VAL.property, (function (i) {
                  return {
                          TAG: /* PrivateProperty */1,
                          _0: i
                        };
                }));
  } else if (variant === "PublicPropertyContext") {
    return Belt_Result.map(x.VAL.property, (function (i) {
                  return {
                          TAG: /* PublicProperty */0,
                          _0: i
                        };
                }));
  } else if (variant === "BroadcastMessageContext") {
    return Belt_Result.map(x.VAL.broadcastMessage, (function (i) {
                  return {
                          TAG: /* BroadcastMessage */6,
                          _0: i
                        };
                }));
  } else {
    return Belt_Result.map(x.VAL.buyerNeed, (function (i) {
                  return {
                          TAG: /* PrivateBuyerNeed */3,
                          _0: i
                        };
                }));
  }
}

function decodeContextOnConversation(obj) {
  return GraphQLConverter.Helpers.decodeOption(decode, obj.context);
}

var ppx_printed_query = "fragment ConversationContext on Conversation   {\nid  \ncontext  {\n__typename\n...on PublicPropertyContext   {\nproperty  {\n..." + ConversationContext__Property.PropertyContext.PropertyContext.name + "   \n}\n\n}\n\n...on PrivatePropertyContext   {\nproperty  {\n..." + ConversationContext__Property.PropertyContext.PropertyContext.name + "   \n}\n\n}\n\n...on PublicBuyerNeedContext   {\nbuyerNeed  {\n..." + ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.name + "   \n}\n\n}\n\n...on PrivateBuyerNeedContext   {\nbuyerNeed  {\n..." + ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.name + "   \n}\n\n}\n\n...on RentalProperty   {\n..." + ConversationContext__RentalProperty.RentalPropertyContext.RentalRentalPropertyContext__RentalProperty.name + "   \n}\n\n...on RentalNeed   {\n..." + ConversationContext__RentalNeed.RentalNeedContext.RentalNeedContext__RentalNeed.name + "   \n}\n\n...on BroadcastMessageContext   {\nbroadcastMessage  {\n..." + BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.name + "   \n}\n\n}\n\n}\n\n}\n" + BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.query + ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.query + ConversationContext__Property.PropertyContext.PropertyContext.query + ConversationContext__RentalNeed.RentalNeedContext.RentalNeedContext__RentalNeed.query + ConversationContext__RentalProperty.RentalPropertyContext.RentalRentalPropertyContext__RentalProperty.query;

function parse(value) {
  var value$1 = value["context"];
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var typename_obj = Js_json.decodeObject(value$1);
    var tmp$1;
    if (typename_obj !== undefined) {
      var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
      if (typename !== undefined) {
        var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
        if (typename$1 !== undefined) {
          switch (typename$1) {
            case "BroadcastMessageContext" :
                tmp$1 = {
                  NAME: "BroadcastMessageContext",
                  VAL: {
                    broadcastMessage: Curry._1(BroadcastMessage__Types.BroadcastMessage.BroadcastMessage.parse, value$1["broadcastMessage"])
                  }
                };
                break;
            case "PrivateBuyerNeedContext" :
                tmp$1 = {
                  NAME: "PrivateBuyerNeedContext",
                  VAL: {
                    buyerNeed: Curry._1(ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.parse, value$1["buyerNeed"])
                  }
                };
                break;
            case "PrivatePropertyContext" :
                tmp$1 = {
                  NAME: "PrivatePropertyContext",
                  VAL: {
                    property: Curry._1(ConversationContext__Property.PropertyContext.PropertyContext.parse, value$1["property"])
                  }
                };
                break;
            case "PublicBuyerNeedContext" :
                tmp$1 = {
                  NAME: "PublicBuyerNeedContext",
                  VAL: {
                    buyerNeed: Curry._1(ConversationContext__BuyerNeed.BuyerNeedContext.BuyerNeedContext__BuyerNeed.parse, value$1["buyerNeed"])
                  }
                };
                break;
            case "PublicPropertyContext" :
                tmp$1 = {
                  NAME: "PublicPropertyContext",
                  VAL: {
                    property: Curry._1(ConversationContext__Property.PropertyContext.PropertyContext.parse, value$1["property"])
                  }
                };
                break;
            case "RentalNeed" :
                tmp$1 = {
                  NAME: "RentalNeed",
                  VAL: Curry._1(ConversationContext__RentalNeed.RentalNeedContext.RentalNeedContext__RentalNeed.parse, value$1)
                };
                break;
            case "RentalProperty" :
                tmp$1 = {
                  NAME: "RentalProperty",
                  VAL: Curry._1(ConversationContext__RentalProperty.RentalPropertyContext.RentalRentalPropertyContext__RentalProperty.parse, value$1)
                };
                break;
            default:
              tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
          }
        } else {
          tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
        }
      } else {
        tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
      }
    } else {
      tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    tmp = tmp$1;
  }
  return decodeContextOnConversation({
              id: value["id"],
              context: tmp
            });
}

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var ConversationContext = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: "ConversationContext",
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var Context = {
  decode: decode,
  decodeContextOnConversation: decodeContextOnConversation,
  ConversationContext: ConversationContext
};

function Conversations__ContextCard$ExpandableHTMLSection(props) {
  var html = props.html;
  var match = React.useState(function () {
        return false;
      });
  var setOverflows = match[1];
  var domRef = React.useRef(undefined);
  React.useEffect((function () {
          var r = domRef.current;
          if (r !== undefined) {
            var r$1 = Caml_option.valFromOption(r);
            Curry._1(setOverflows, (function (param) {
                    return (r$1.scrollHeight - 2 | 0) > r$1.clientHeight;
                  }));
          }
          
        }), [html]);
  var match$1 = React.useState(function () {
        return false;
      });
  var setIsOpen = match$1[1];
  var isOpen = match$1[0];
  var toggle = function (param) {
    Curry._1(setIsOpen, (function (v) {
            return !v;
          }));
  };
  return React.createElement(View__Jsx3.make, {
              flexDirection: "column",
              children: Caml_option.some(null)
            }, React.createElement(HtmlHolder.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.overflow("hidden"),
                        tl: {
                          hd: Css.maxHeight(isOpen ? "none" : ({
                                    NAME: "em",
                                    VAL: 4.5
                                  })),
                          tl: {
                            hd: Css.marginBottom({
                                  NAME: "px",
                                  VAL: 5
                                }),
                            tl: {
                              hd: Css.fontSize({
                                    NAME: "px",
                                    VAL: 16
                                  }),
                              tl: {
                                hd: Css.lineHeight({
                                      NAME: "em",
                                      VAL: 1.5
                                    }),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }),
                  innerRef: Caml_option.some(function (e) {
                        Utils.React.setCurrentRef(domRef, (e == null) ? undefined : Caml_option.some(e));
                      }),
                  innerHtml: html
                }), match[0] ? React.createElement(Touchable__Jsx3.make, {
                    style: {
                      hd: Css.alignItems("center"),
                      tl: {
                        hd: Css.color(Theme__Color.calypso),
                        tl: {
                          hd: Css.cursor("pointer"),
                          tl: {
                            hd: Css.hover({
                                  hd: Css.textDecoration("underline"),
                                  tl: /* [] */0
                                }),
                            tl: /* [] */0
                          }
                        }
                      }
                    },
                    onPress: toggle,
                    children: null
                  }, isOpen ? "Less" : "More", React.createElement("span", {
                        className: Curry._1(Css.style, {
                              hd: Css.display("inlineFlex"),
                              tl: {
                                hd: Css.paddingLeft({
                                      NAME: "px",
                                      VAL: 5
                                    }),
                                tl: /* [] */0
                              }
                            })
                      }, React.createElement(Icon__Jsx3.make, {
                            icon: isOpen ? /* ArrowUp */9 : /* ArrowDown */5,
                            size: 10
                          }))) : null);
}

var ExpandableHTMLSection = {
  make: Conversations__ContextCard$ExpandableHTMLSection
};

function Conversations__ContextCard$RentalPropertyContextCard(props) {
  var context = props.context;
  var agentIsCurrentUser = CurrentUser.agentIsCurrentUser(context.agent.id);
  var rentalProperty = context.property;
  var $$location = Property.DisplayLocation.toString(rentalProperty.location);
  var button = React.createElement(Buttons__Jsx3.SecondaryButton.make, {
        size: "small",
        icon: /* ViewDetails */75,
        children: "View details"
      });
  var match = context.client;
  var tmp;
  var exit = 0;
  if (agentIsCurrentUser && match !== undefined) {
    tmp = React.createElement(Next__Atoms.Link.make, {
          href: "/my_clients/" + match.id,
          children: button
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement(Next__Atoms.Link.make, {
          href: "/properties/" + rentalProperty.id,
          children: button
        });
  }
  return React.createElement(ConversationContextCard__Jsx3.MediaSection.make, {
              image: ReactRender.fromOption(Belt_Option.map(Belt_Array.get(rentalProperty.images, 0), (function (param) {
                          return Utils__AttachmentUrl.makeAttachmentUrl(324, 324, false, true, undefined, undefined, param.key);
                        })), (function (src) {
                      return React.createElement(ConversationContextCard__Jsx3.PropertyImage.make, {
                                  src: src,
                                  alt: $$location
                                });
                    })),
              content: React.createElement(ConversationContextCard__Jsx3.ContentSection.make, {
                    children: null
                  }, React.createElement(ConversationContextCard__Jsx3.TitleSection.make, {
                        title: Caml_option.some($$location),
                        label: Caml_option.some(React.createElement(Labels.MLSLabel.make, {
                                  variant: Curry._3(Labels.MLSLabel.Variant.fromRentalMlsPlans, rentalProperty.timeZone, rentalProperty.activeOnMls, rentalProperty.mlsPlans)
                                })),
                        price: TMPUIKIT___Price__Jsx3.formatPrice(rentalProperty.price),
                        subtitle: Caml_option.some(React.createElement(Property__Components__Address.make, {
                                  address: rentalProperty.address
                                }))
                      }), React.createElement(View__Jsx3.make, {
                        mb: {
                          NAME: "px",
                          VAL: 25
                        },
                        children: Caml_option.some(React.createElement(Conversations__ContextCard$ExpandableHTMLSection, {
                                  html: rentalProperty.description
                                }))
                      }), React.createElement(View__Jsx3.make, {
                        mb: ConversationContextCard__Jsx3.responsive({
                              NAME: "px",
                              VAL: 15
                            }, undefined, {
                              NAME: "px",
                              VAL: 10
                            }, undefined, undefined, undefined, undefined),
                        children: Caml_option.some(React.createElement(ViewStack.make, {
                                  mt: "md",
                                  space: "sm",
                                  flexDirection: "column",
                                  children: Caml_option.some(null)
                                }, React.createElement(CardComponents.RentalPropertyAttributes.make, {
                                      attributes: rentalProperty.attributes
                                    }), React.createElement(CardComponents.RentalPropertyLease.make, {
                                      lease: rentalProperty.lease
                                    })))
                      }), React.createElement(View__Jsx3.make, {
                        children: Caml_option.some(tmp)
                      }))
            });
}

var RentalPropertyContextCard = {
  make: Conversations__ContextCard$RentalPropertyContextCard
};

function Conversations__ContextCard$RentalNeedContextCard(props) {
  var context = props.context;
  var agentIsCurrentUser = CurrentUser.agentIsCurrentUser(context.agent.id);
  var rentalNeed = context.rentalNeed;
  var button = React.createElement(Buttons__Jsx3.SecondaryButton.make, {
        size: "small",
        icon: /* ViewDetails */75,
        children: "View details"
      });
  var match = context.client;
  var tmp;
  var exit = 0;
  if (agentIsCurrentUser && match !== undefined) {
    tmp = React.createElement(View__Jsx3.make, {
          mt: {
            NAME: "px",
            VAL: 15
          },
          children: Caml_option.some(React.createElement(Next__Atoms.Link.make, {
                    href: "/my_clients/" + match.id,
                    children: button
                  }))
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement(View__Jsx3.make, {
          mt: {
            NAME: "px",
            VAL: 15
          },
          children: Caml_option.some(React.createElement(Next__Atoms.Link.make, {
                    href: "/client_needs/" + rentalNeed.id,
                    children: button
                  }))
        });
  }
  return React.createElement(ConversationContextCard__Jsx3.ContentSection.make, {
              children: null
            }, React.createElement(ConversationContextCard__Jsx3.TitleSection.make, {
                  title: Caml_option.some(rentalNeed.headline),
                  label: Caml_option.some(React.createElement(CardComponents.RentalNeedLabels.make, {
                            status: rentalNeed.status
                          })),
                  price: TMPUIKIT___Price__Jsx3.formatPrice(rentalNeed.priceRange),
                  subtitle: Caml_option.some(React.createElement(Text__Jsx3.make, {
                            fontStyle: "italic",
                            children: React.createElement(PseudoJoin.make, {
                                  children: Belt_Array.map(rentalNeed.areas, (function (area) {
                                          return JsxPPXReactSupport.createElementWithKey(area.id, Clients__Components__AreaText.make, {
                                                      area: area
                                                    });
                                        })),
                                  with_: ", "
                                })
                          }))
                }), React.createElement(CardComponents.NeededPropertyTypes.make, {
                  propertyTypes: rentalNeed.propertyTypes,
                  minBeds: rentalNeed.minBeds
                }), React.createElement(View__Jsx3.make, {
                  mt: "sm"
                }), React.createElement(CardComponents.RentalNeedLease.make, {
                  lease: rentalNeed.lease
                }), React.createElement(View__Jsx3.make, {
                  mt: {
                    NAME: "px",
                    VAL: 15
                  },
                  children: Caml_option.some(React.createElement(Conversations__ContextCard$ExpandableHTMLSection, {
                            html: rentalNeed.remarks
                          }))
                }), tmp);
}

var RentalNeedContextCard = {
  make: Conversations__ContextCard$RentalNeedContextCard
};

function Conversations__ContextCard$PropertyContextCard(props) {
  var context = props.context;
  var property = context.property;
  var $$location = Property.DisplayLocation.toString(property.location);
  var visibility = property.visibility;
  var agent = property.agent;
  var agentIsCurrentUser = agent ? CurrentUser.agentIsCurrentUser(agent._0.id) : false;
  var match = property.agent;
  var match$1 = property.visibility;
  var match$2 = property.anonymousMatching;
  var button = React.createElement(Buttons__Jsx3.SecondaryButton.make, {
        size: "small",
        icon: /* ViewDetails */75,
        children: "View details"
      });
  var match$3 = context.client;
  var tmp;
  var exit = 0;
  if (agentIsCurrentUser) {
    if (match$3 !== undefined) {
      tmp = React.createElement(Next__Atoms.Link.make, {
            href: "/my_clients/" + match$3.id,
            children: button
          });
    } else if (visibility === "PUBLIC") {
      exit = 1;
    } else {
      tmp = null;
    }
  } else if (visibility === "PUBLIC") {
    exit = 1;
  } else {
    tmp = null;
  }
  if (exit === 1) {
    tmp = React.createElement(Next__Atoms.Link.make, {
          href: "/properties/" + property.id,
          children: button
        });
  }
  return React.createElement(ConversationContextCard__Jsx3.MediaSection.make, {
              image: ReactRender.fromOption(Belt_Option.map(Belt_Array.get(property.images, 0), (function (param) {
                          return Utils__AttachmentUrl.makeAttachmentUrl(324, 324, false, true, undefined, undefined, param.key);
                        })), (function (src) {
                      return React.createElement(ConversationContextCard__Jsx3.PropertyImage.make, {
                                  src: src,
                                  alt: $$location
                                });
                    })),
              content: React.createElement(ConversationContextCard__Jsx3.ContentSection.make, {
                    children: null
                  }, React.createElement(ConversationContextCard__Jsx3.TitleSection.make, {
                        title: Caml_option.some($$location),
                        label: Caml_option.some(match ? (
                                match$1 === "PUBLIC" ? React.createElement(Labels.MLSLabel.make, {
                                        variant: Curry._3(Labels.MLSLabel.Variant.fromMlsPlans, property.timeZone, property.activeOnMls, property.mlsPlans)
                                      }) : (
                                    match$2 ? React.createElement(Labels.AnonymousMatchingLabel.make, {}) : React.createElement(Labels.QuietSellerLabel.make, {})
                                  )
                              ) : React.createElement(Labels.AnonymousAgentLabel.make, {})),
                        price: TMPUIKIT___Price__Jsx3.formatPrice(property.price),
                        subtitle: Caml_option.some(React.createElement(Property__Components__Address.make, {
                                  address: property.address
                                }))
                      }), React.createElement(View__Jsx3.make, {
                        mb: {
                          NAME: "px",
                          VAL: 25
                        },
                        children: Caml_option.some(React.createElement(Conversations__ContextCard$ExpandableHTMLSection, {
                                  html: Property.Description.toString(property.description)
                                }))
                      }), React.createElement(View__Jsx3.make, {
                        mb: ConversationContextCard__Jsx3.responsive({
                              NAME: "px",
                              VAL: 15
                            }, undefined, {
                              NAME: "px",
                              VAL: 10
                            }, undefined, undefined, undefined, undefined),
                        children: Caml_option.some(React.createElement(CardComponents.PropertyAttributes.make, {
                                  attributes: property.attributes
                                }))
                      }), React.createElement(View__Jsx3.make, {
                        children: Caml_option.some(tmp)
                      }))
            });
}

var PropertyContextCard = {
  make: Conversations__ContextCard$PropertyContextCard
};

function Conversations__ContextCard$BuyerNeedContextCard(props) {
  var context = props.context;
  var buyerNeed = context.buyerNeed;
  var agentIsCurrentUser = CurrentUser.agentIsCurrentUser(context.buyerNeed.agent.id);
  var visibility = context.buyerNeed.visibility;
  var match = context.client;
  var match$1 = buyerNeed.headline;
  var button = React.createElement(Buttons__Jsx3.SecondaryButton.make, {
        size: "small",
        icon: /* ViewDetails */75,
        children: "View details"
      });
  var match$2 = context.client;
  var tmp;
  var exit = 0;
  if (agentIsCurrentUser) {
    if (match$2 !== undefined) {
      tmp = React.createElement(View__Jsx3.make, {
            mt: {
              NAME: "px",
              VAL: 15
            },
            children: Caml_option.some(React.createElement(Next__Atoms.Link.make, {
                      href: "/my_clients/" + match$2.id,
                      children: button
                    }))
          });
    } else {
      exit = 1;
    }
  } else if (visibility === "PUBLIC") {
    exit = 1;
  } else {
    tmp = null;
  }
  if (exit === 1) {
    tmp = React.createElement(View__Jsx3.make, {
          mt: {
            NAME: "px",
            VAL: 15
          },
          children: Caml_option.some(React.createElement(Next__Atoms.Link.make, {
                    href: "/client_needs/" + buyerNeed.id,
                    children: button
                  }))
        });
  }
  return JsxPPXReactSupport.createElementVariadicWithKey(buyerNeed.id, ConversationContextCard__Jsx3.ContentSection.make, {
              children: null
            }, [
              React.createElement(ConversationContextCard__Jsx3.TitleSection.make, {
                    title: Caml_option.some(agentIsCurrentUser ? (
                            match !== undefined ? Belt_Option.getWithDefault(Client.label(match), "Buyer") : (
                                typeof match$1 === "object" ? match$1.VAL : "Quiet buyer"
                              )
                          ) : (
                            typeof match$1 === "object" ? match$1.VAL : "Quiet buyer"
                          )),
                    label: Caml_option.some(visibility === "PUBLIC" ? null : React.createElement(Labels.QuietBuyerLabel.make, {})),
                    price: TMPUIKIT___Price__Jsx3.formatPrice(buyerNeed.priceRange),
                    subtitle: Caml_option.some(React.createElement(Text__Jsx3.make, {
                              fontStyle: "italic",
                              children: React.createElement(PseudoJoin.make, {
                                    children: $$Array.map((function (area) {
                                            return JsxPPXReactSupport.createElementWithKey(area.id, Clients__Components__AreaText.make, {
                                                        area: area
                                                      });
                                          }), buyerNeed.areas),
                                    with_: ", "
                                  })
                            }))
                  }),
              React.createElement(View__Jsx3.make, {
                    children: Caml_option.some(React.createElement(Text__Jsx3.make, {
                              fontSize: {
                                NAME: "px",
                                VAL: 14
                              },
                              color: Colors.gray,
                              children: Utils.$$Array.joinWith(", ", Belt_Array.concat(Belt_Array.map(buyerNeed.propertyTypes, Types__Common.PropertyType.toDisplayString), Belt_Option.mapWithDefault(Belt_Option.map(buyerNeed.minBeds, BuyerNeed.Basic.minBedsDisplayString), [], (function (a) {
                                              return [a];
                                            }))))
                            }))
                  }),
              React.createElement(View__Jsx3.make, {
                    mt: {
                      NAME: "px",
                      VAL: 15
                    },
                    children: Caml_option.some(React.createElement(Conversations__ContextCard$ExpandableHTMLSection, {
                              html: buyerNeed.remarks
                            }))
                  }),
              tmp
            ]);
}

var BuyerNeedContextCard = {
  make: Conversations__ContextCard$BuyerNeedContextCard
};

function Conversations__ContextCard$RemovedContextCard(props) {
  var entityOwner = props.entityOwner;
  var entityType = props.entityType;
  var tmp;
  if (entityOwner) {
    var owner = entityOwner._0;
    var match = owner.membershipStatus;
    tmp = match === "TERMINATED" ? "This " + (Entity.Type.toString(entityType) + (" has been removed as " + (Types__User.label(owner) + " no longer has an active subscription on TAN"))) : "This " + (Entity.Type.toString(entityType) + " has been removed from TAN");
  } else {
    tmp = "This " + (Entity.Type.toString(entityType) + " has been removed from TAN");
  }
  return React.createElement(ConversationContextCard__Jsx3.ContentSection.make, {
              children: React.createElement(View__Jsx3.make, {
                    p: "md",
                    children: Caml_option.some(tmp)
                  })
            });
}

var RemovedContextCard = {
  EntityType: undefined,
  make: Conversations__ContextCard$RemovedContextCard
};

function Conversations__ContextCard$EntityCard(props) {
  var context = props.context;
  var tmp;
  switch (context.TAG | 0) {
    case /* PublicProperty */0 :
        var context$1 = context._0;
        var match = context$1.property;
        tmp = match.status.listingStatus === 3 ? React.createElement(Conversations__ContextCard$RemovedContextCard, {
                entityType: /* Property */0,
                entityOwner: match.agent
              }) : React.createElement(Conversations__ContextCard$PropertyContextCard, {
                context: context$1
              });
        break;
    case /* PrivateProperty */1 :
        var context$2 = context._0;
        var match$1 = context$2.property;
        tmp = match$1.status.listingStatus === 3 ? React.createElement(Conversations__ContextCard$RemovedContextCard, {
                entityType: /* Property */0,
                entityOwner: match$1.agent
              }) : React.createElement(Conversations__ContextCard$PropertyContextCard, {
                context: context$2
              });
        break;
    case /* PublicBuyerNeed */2 :
        var context$3 = context._0;
        var match$2 = context$3.buyerNeed;
        tmp = match$2.status.status === 4 ? React.createElement(Conversations__ContextCard$RemovedContextCard, {
                entityType: /* BuyerNeed */1,
                entityOwner: /* User */{
                  _0: match$2.agent
                }
              }) : React.createElement(Conversations__ContextCard$BuyerNeedContextCard, {
                context: context$3
              });
        break;
    case /* PrivateBuyerNeed */3 :
        var context$4 = context._0;
        var match$3 = context$4.buyerNeed;
        tmp = match$3.status.status === 4 ? React.createElement(Conversations__ContextCard$RemovedContextCard, {
                entityType: /* BuyerNeed */1,
                entityOwner: /* User */{
                  _0: match$3.agent
                }
              }) : React.createElement(Conversations__ContextCard$BuyerNeedContextCard, {
                context: context$4
              });
        break;
    case /* RentalProperty */4 :
        var context$5 = context._0;
        var match$4 = context$5.property.status.listingStatus;
        tmp = typeof match$4 === "number" && match$4 >= 4 ? React.createElement(Conversations__ContextCard$RemovedContextCard, {
                entityType: /* RentalProperty */2,
                entityOwner: /* User */{
                  _0: context$5.agent
                }
              }) : React.createElement(Conversations__ContextCard$RentalPropertyContextCard, {
                context: context$5
              });
        break;
    case /* RentalNeed */5 :
        var context$6 = context._0;
        var match$5 = context$6.rentalNeed.status.status;
        tmp = typeof match$5 === "number" && match$5 >= 4 ? React.createElement(Conversations__ContextCard$RemovedContextCard, {
                entityType: /* RentalNeed */3,
                entityOwner: /* User */{
                  _0: context$6.agent
                }
              }) : React.createElement(Conversations__ContextCard$RentalNeedContextCard, {
                context: context$6
              });
        break;
    case /* BroadcastMessage */6 :
        var match$6 = context._0;
        var agent = match$6.agent;
        tmp = match$6.status === "DELETED" ? React.createElement(Conversations__ContextCard$RemovedContextCard, {
                entityType: /* BroadcastMessage */4,
                entityOwner: /* User */{
                  _0: agent
                }
              }) : React.createElement(ConversationContextCard__Jsx3.ContentSection.make, {
                children: null
              }, React.createElement(User__Components.AgentInfoBlock.make, {
                    agent: agent
                  }), React.createElement(View__Jsx3.make, {
                    mt: {
                      NAME: "px",
                      VAL: 15
                    },
                    flexDirection: "column",
                    children: Caml_option.some(null)
                  }, React.createElement(View__Jsx3.make, {
                        mb: {
                          NAME: "px",
                          VAL: 5
                        },
                        children: Caml_option.some(React.createElement(Text__Jsx3.make, {
                                  textTransform: "uppercase",
                                  fontWeight: "light",
                                  color: Colors.jumbo,
                                  children: match$6.category.shortName
                                }))
                      }), React.createElement(Card__Jsx3.CardTitle.make, {
                        children: match$6.subject
                      }), React.createElement(Conversations__ContextCard$ExpandableHTMLSection, {
                        html: match$6.body
                      })));
        break;
    
  }
  return React.createElement(ConversationContextCard__Jsx3.make, {
              children: tmp
            });
}

var EntityCard = {
  make: Conversations__ContextCard$EntityCard
};

function Conversations__ContextCard$UsersMatchesCard$RenterMatches(props) {
  return Belt_Array.map(props.matches, (function (match_) {
                var client = match_.rentalNeed.client;
                var clientNames = Client.label(client);
                return JsxPPXReactSupport.createElementVariadicWithKey(match_.id, View__Jsx3.make, {
                            children: Caml_option.some(null)
                          }, [
                            React.createElement(Next__Atoms.Link.make, {
                                  href: "/my_clients/" + client.id,
                                  children: Belt_Option.getWithDefault(clientNames, "Renter")
                                }),
                            ", ",
                            React.createElement(Text__Jsx3.make, {
                                  fontSize: {
                                    NAME: "px",
                                    VAL: 14
                                  },
                                  color: Colors.tussock,
                                  children: TMPUIKIT___Price__Jsx3.formatPrice(match_.rentalNeed.price)
                                })
                          ]);
              }));
}

var RenterMatches = {
  make: Conversations__ContextCard$UsersMatchesCard$RenterMatches
};

function Conversations__ContextCard$UsersMatchesCard$RentalOwnerMatches(props) {
  return Belt_Array.map(props.matches, (function (match_) {
                var client = match_.rentalProperty.client;
                var clientNames = Client.label(client);
                return JsxPPXReactSupport.createElementVariadicWithKey(match_.id, View__Jsx3.make, {
                            children: Caml_option.some(null)
                          }, [
                            React.createElement(Next__Atoms.Link.make, {
                                  href: "/my_clients/" + client.id,
                                  children: Belt_Option.getWithDefault(clientNames, "Rental Owner at " + Belt_Option.getWithDefault(RentalProperty.RentalAddress.toString(match_.rentalProperty.address), ""))
                                }),
                            Belt_Option.isSome(clientNames) ? React.createElement(React.Fragment, undefined, ", ", React.createElement(Property__Components__Address.make, {
                                        address: match_.rentalProperty.address
                                      })) : null,
                            ", ",
                            Property.DisplayLocation.toString(match_.rentalProperty.location),
                            React.createElement(Text__Jsx3.make, {
                                  fontSize: {
                                    NAME: "px",
                                    VAL: 14
                                  },
                                  color: Colors.tussock,
                                  children: " " + TMPUIKIT___Price__Jsx3.formatPrice(match_.rentalProperty.price)
                                })
                          ]);
              }));
}

var RentalOwnerMatches = {
  make: Conversations__ContextCard$UsersMatchesCard$RentalOwnerMatches
};

function Conversations__ContextCard$UsersMatchesCard$SellerMatches(props) {
  return Belt_Array.map(props.matches, (function (match_) {
                var match = Client.label(match_.property.client);
                var match$1 = match_.property.address;
                var names;
                if (match !== undefined) {
                  names = match;
                } else if (match$1.NAME === "Public") {
                  names = "Seller at " + match$1.VAL;
                } else {
                  var address = match$1.VAL;
                  names = address !== undefined ? "Seller at " + address : "Error loading client details ";
                }
                return JsxPPXReactSupport.createElementVariadicWithKey(match_.id, View__Jsx3.make, {
                            children: Caml_option.some(null)
                          }, [
                            React.createElement(Next__Atoms.Link.make, {
                                  href: "/my_clients/" + match_.property.client.id,
                                  children: names
                                }),
                            Belt_Option.isSome(Client.label(match_.property.client)) ? React.createElement(React.Fragment, undefined, ", ", React.createElement(Property__Components__Address.make, {
                                        address: match_.property.address
                                      })) : null,
                            ", ",
                            " " + Property.DisplayLocation.toString(match_.property.location),
                            React.createElement(Text__Jsx3.make, {
                                  fontSize: {
                                    NAME: "px",
                                    VAL: 14
                                  },
                                  color: Colors.tussock,
                                  children: " " + TMPUIKIT___Price__Jsx3.formatPrice(match_.property.price)
                                })
                          ]);
              }));
}

var SellerMatches = {
  make: Conversations__ContextCard$UsersMatchesCard$SellerMatches
};

function Conversations__ContextCard$UsersMatchesCard$BuyerMatches(props) {
  return Belt_Array.map(props.matches, (function (match_) {
                var names = Belt_Option.getWithDefault(Client.label(match_.buyerNeed.client), "Buyer");
                return JsxPPXReactSupport.createElementVariadicWithKey(match_.id, View__Jsx3.make, {
                            children: Caml_option.some(null)
                          }, [
                            React.createElement(Next__Atoms.Link.make, {
                                  href: "/my_clients/" + match_.buyerNeed.client.id,
                                  children: names
                                }),
                            ", ",
                            React.createElement(Text__Jsx3.make, {
                                  fontSize: {
                                    NAME: "px",
                                    VAL: 14
                                  },
                                  color: Colors.tussock,
                                  children: TMPUIKIT___Price__Jsx3.formatPrice(match_.buyerNeed.price)
                                })
                          ]);
              }));
}

var BuyerMatches = {
  make: Conversations__ContextCard$UsersMatchesCard$BuyerMatches
};

function Conversations__ContextCard$UsersMatchesCard(props) {
  var context = props.context;
  var x = Conversations__Types.Context.getOwner(context);
  var agentIsOwner = x ? CurrentUser.sameAccountAsCurrentUser(x._0, undefined) : false;
  var match = Conversations__Types.Context.getMatches(context);
  var title;
  if (typeof match === "object") {
    var variant = match.NAME;
    if (variant === "SELLER_MATCHES") {
      var len = match.VAL.length;
      title = len !== 1 ? (
          len !== 0 ? "Your matching active sellers:" : "You have no matching active sellers"
        ) : "Your matching active seller:";
    } else if (variant === "RENTAL_OWNER_MATCHES") {
      var len$1 = match.VAL.length;
      title = len$1 !== 1 ? (
          len$1 !== 0 ? "Your matching active rental owners:" : "You have no matching active rental owners"
        ) : "Your matching active rental owner:";
    } else if (variant === "RENTER_MATCHES") {
      var len$2 = match.VAL.length;
      title = len$2 !== 1 ? (
          len$2 !== 0 ? "Your matching active renters:" : "You have no matching active renters"
        ) : "Your matching active renter:";
    } else {
      var len$3 = match.VAL.length;
      title = len$3 !== 1 ? (
          len$3 !== 0 ? "Your matching active buyers:" : "You have no matching active buyers"
        ) : "Your matching active buyer:";
    }
  } else {
    title = match === "ERROR_GETTING_MATCHES" ? "There was a problem loading matches" : undefined;
  }
  if (agentIsOwner || Conversations__Types.Context.isRemoved(context)) {
    return null;
  } else {
    return ReactRender.fromOption(title, (function (titleString) {
                  var match = Conversations__Types.Context.getMatches(context);
                  var tmp;
                  if (typeof match === "object") {
                    var variant = match.NAME;
                    if (variant === "SELLER_MATCHES") {
                      var matches = match.VAL;
                      tmp = matches.length !== 0 ? React.createElement(Conversations__ContextCard$UsersMatchesCard$SellerMatches, {
                              matches: matches
                            }) : null;
                    } else if (variant === "RENTAL_OWNER_MATCHES") {
                      var matches$1 = match.VAL;
                      tmp = matches$1.length !== 0 ? React.createElement(Conversations__ContextCard$UsersMatchesCard$RentalOwnerMatches, {
                              matches: matches$1
                            }) : null;
                    } else if (variant === "RENTER_MATCHES") {
                      var matches$2 = match.VAL;
                      tmp = matches$2.length !== 0 ? React.createElement(Conversations__ContextCard$UsersMatchesCard$RenterMatches, {
                              matches: matches$2
                            }) : null;
                    } else {
                      var matches$3 = match.VAL;
                      tmp = matches$3.length !== 0 ? React.createElement(Conversations__ContextCard$UsersMatchesCard$BuyerMatches, {
                              matches: matches$3
                            }) : null;
                    }
                  } else {
                    tmp = null;
                  }
                  return React.createElement(View__Jsx3.make, {
                              mt: {
                                NAME: "px",
                                VAL: 20
                              },
                              children: Caml_option.some(React.createElement(ConversationContextCard__Jsx3.make, {
                                        children: React.createElement(ConversationContextCard__Jsx3.ContentSection.make, {
                                              children: null
                                            }, React.createElement(ConversationContextCard__Jsx3.LockedSection.make, {
                                                  children: React.createElement(Text__Jsx3.make, {
                                                        as_: "div",
                                                        fontSize: {
                                                          NAME: "px",
                                                          VAL: 14
                                                        },
                                                        color: Colors.gray,
                                                        children: "Only visible to you:"
                                                      })
                                                }), React.createElement(Text__Jsx3.make, {
                                                  as_: "div",
                                                  lineHeight: {
                                                    NAME: "em",
                                                    VAL: 3
                                                  },
                                                  fontWeight: "bold",
                                                  children: titleString
                                                }), React.createElement(ViewStack.make, {
                                                  space: "xs",
                                                  flexDirection: "column",
                                                  children: Caml_option.some(tmp)
                                                }))
                                      }))
                            });
                }));
  }
}

var UsersMatchesCard = {
  RenterMatches: RenterMatches,
  RentalOwnerMatches: RentalOwnerMatches,
  SellerMatches: SellerMatches,
  BuyerMatches: BuyerMatches,
  make: Conversations__ContextCard$UsersMatchesCard
};

function Conversations__ContextCard(props) {
  var context = props.context;
  return React.createElement(React.Fragment, undefined, React.createElement(Conversations__ContextCard$EntityCard, {
                  context: context
                }), React.createElement(Conversations__ContextCard$UsersMatchesCard, {
                  context: context
                }));
}

var Fragment;

var Buttons;

var make = Conversations__ContextCard;

exports.Context = Context;
exports.Fragment = Fragment;
exports.ExpandableHTMLSection = ExpandableHTMLSection;
exports.Buttons = Buttons;
exports.RentalPropertyContextCard = RentalPropertyContextCard;
exports.RentalNeedContextCard = RentalNeedContextCard;
exports.PropertyContextCard = PropertyContextCard;
exports.BuyerNeedContextCard = BuyerNeedContextCard;
exports.RemovedContextCard = RemovedContextCard;
exports.EntityCard = EntityCard;
exports.UsersMatchesCard = UsersMatchesCard;
exports.make = make;
/* Css Not a pure module */
